export default "<go-input [control]=\"control\" [label]=\"label\" [placeholder]=\"placeholder\"> </go-input>\n";